import { useMemo, useState } from 'react';

import type { FrapiTeaserItem } from '../../types/frapi-types.js';
import type { SortConfig } from '../layouts/front/sectionHelpers.js';

export type UseSortHook = {
  sortedItems: FrapiTeaserItem[];
  handleSort: (config: SortConfig) => void;
  sortConfig: SortConfig | null;
};

const generateTime = (teaser: FrapiTeaserItem): number =>
  new Date(teaser.publicationDate).getTime();

export const useSort = (
  results: FrapiTeaserItem[],
  config: SortConfig | null,
): UseSortHook => {
  const [sortConfig, setSortConfig] = useState<SortConfig | null>(config);

  const sortedItems = useMemo(() => {
    if (sortConfig) {
      const sorted = [...results].sort(
        (a: FrapiTeaserItem, b: FrapiTeaserItem) => {
          switch (sortConfig) {
            case 'date':
              return generateTime(b) - generateTime(a);
            case 'grade':
              return (b.grade || 0) - (a.grade || 0);
            default:
              return 0;
          }
        },
      );

      return sorted;
    }

    return results;
  }, [results, sortConfig]);

  const handleSort = (config: SortConfig) => {
    setSortConfig(config);

    const url = new URL(location.href);
    url.searchParams.set('sorting', config);
    window.history.pushState(null, '', url);
  };

  return {
    sortedItems,
    handleSort,
    sortConfig,
  };
};
